<template>
    <div>
        <modal id="event-modal" size="large" v-model="showModal" @submit="submit" :preloader="preloader"
            :loading="loading" :title="selectedUrl ? $t('edit') : $t('create')" :submit-btn-class="'btn-primary'" :btn-label="$t('save')">
            <form ref="form" @submit.prevent="submit" :data-url="selectedUrl ? selectedUrl : url">
                <!-- <div class="row">
                    <div class="col-12">
                        <h5>{{ $t('manage_sections') }}</h5>
                    </div>
                    <div class="col-md-5">
                        <div class="form-group">
                            <label>{{ $t('new_section_name') }}</label>
                            <input type="text" class="form-control" v-model="newSection.name">
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="form-group">
                            <label>{{ $t('order') }}</label>
                            <input type="number" class="form-control" v-model.number="newSection.order_no">
                        </div>
                    </div>
                    <div class="col-md-4 d-flex align-items-end">
                        <div class="form-group">
                            <button type="button" class="btn btn-success" @click="addSection">{{ $t('add_section') }}</button>
                        </div>
                    </div>
                </div> -->
                <!-- date  -->
                <div class="row">
                    <div class="col-md-12">
                        <div class="form-group">
                            <label>{{ $t('date') }}</label>
                            <app-input type="date" v-model="formData.date"
                                :error-message="$errorMessage(errors, 'date')" />
                        </div>
                    </div>
                </div>
                <hr class="my-4">

                <div v-for="(item, index) in formData.items" :key="index" class="border p-3 mb-3 position-relative">
                    <div v-if="formData.items.length > 1" class="position-absolute" style="top: 5px; right: 5px;">
                        <button type="button" class="btn btn-sm btn-danger" @click="removeItem(index)">{{ $t('remove') }}</button>
                    </div>

                    <div class="row">
                        <div class="col-md-6">
                            <div class="form-group">
                                <label :for="'category-' + index">{{ $t('category') }}</label>
                                <select :id="'category-' + index" class="form-control custom-select" v-model="item.category" name="category"
                                    :class="{ 'is-invalid': errors[`items.${index}.category`] }">
                                    <option value="" disabled>{{ $t('select_categories') }}</option>
                                    <option value="holiday">{{ $t('holiday') }}</option>
                                    <option value="company_event">{{ $t('company_event') }}</option>
                                    <!-- <option value="birthday">{{ $t('birthday') }}</option>
                                    <option value="work_anniversary">{{ $t('work_anniversary') }}</option> -->
                                </select>
                                <div class="invalid-feedback" v-if="errors[`items.${index}.category`]">
                                    {{ errors[`items.${index}.category`][0] }}
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <label :for="'section-' + index">{{ $t('section') }}</label>
                                <select :id="'section-' + index" class="form-control custom-select" v-model="item.section" name="section"
                                    :class="{ 'is-invalid': errors[`items.${index}.section`] }">
                                    <!-- <option value="" disabled>{{ $t('select_section') }}</option> -->
                                    <option v-for="section in formData.sectionOption" :key="section.id" :value="section.id">{{ section.name }}</option>
                                </select>
                                <div class="invalid-feedback" v-if="errors[`items.${index}.section`]">
                                    {{ errors[`items.${index}.section`][0] }}
                                </div>
                            </div>
                        </div>
                    </div>

                    <template v-if="item.category === 'holiday' || item.category === 'company_event'">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label :for="'name_event-' + index">{{ $t('name') }}</label>
                                    <app-input type="text" :id="'name_event-' + index" v-model="item.name_event"
                                        :placeholder="$t('e.g._khmer_new_year')"
                                        :required="item.category === 'holiday' || item.category === 'company_event'"
                                        :error-message="$errorMessage(errors, `items.${index}.name_event`)" />
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label :for="'description-' + index">{{ $t('description') }}</label>
                                    <app-input type="textarea" :id="'description-' + index" v-model="item.description"
                                               :placeholder="$t('e.g. Event Description')"/>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <!-- <div class="form-group">
                                    <label :for="'date_event-' + index">{{ $t('date') }}</label>
                                    <app-input type="date" :id="'date_event-' + index" v-model="item.date_event"
                                        :required="true"
                                        :error-message="$errorMessage(errors, `items.${index}.date_event`)" />
                                </div> -->
                            </div>
                        </div>
                        <div class="row" v-if="item.category === 'company_event'">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label :for="'start_time-' + index">{{ $t('start_time') }}</label>
                                    <app-input type="time" :id="'start_time-' + index" v-model="item.start_time"
                                        :required="item.category === 'company_event'"
                                        :error-message="$errorMessage(errors, `items.${index}.start_time`)" />
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label :for="'end_time-' + index">{{ $t('end_time') }}</label>
                                    <app-input type="time" :id="'end_time-' + index" v-model="item.end_time"
                                        :required="item.category === 'company_event'"
                                        :error-message="$errorMessage(errors, `items.${index}.end_time`)" />
                                </div>
                            </div>
                        </div>
                    </template>

                    <template v-if="item.category === 'birthday' || item.category === 'work_anniversary'">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label>{{ $t('employee_name') }}</label>
                                    <app-input type="text" v-model="item.employee_name"
                                        :placeholder="$t('e.g. Dara K.')"
                                        :required="item.category === 'birthday' || item.category === 'work_anniversary'"
                                        :error-message="$errorMessage(errors, `items.${index}.employee_name`)" />
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <!-- <div class="col-md-6">
                                <div class="form-group">
                                    <label>{{ $t('date') }}</label>
                                    <app-input type="date" v-model="item.date_event"
                                        :required="true"
                                        :error-message="$errorMessage(errors, `items.${index}.date_event`)" />
                                </div>
                            </div> -->
                            <div class="col-md-6" v-if="item.category === 'work_anniversary'">
                                <div class="form-group">
                                    <label>{{ $t('years_completed') }}</label>
                                    <app-input type="number" v-model="item.years_count" :placeholder="$t('e.g. 3')"
                                        :required="item.category === 'work_anniversary'"
                                        :error-message="$errorMessage(errors, `items.${index}.years_count`)" />
                                </div>
                            </div>
                        </div>
                    </template>
                </div>

                <button  type="button" class="btn btn-primary" @click="addItem">{{ $t('add_another_item') }}</button>

            </form>
        </modal>
    </div>
</template>

<script>
import { FormMixin } from "../../../../../core/mixins/form/FormMixin";
import { EVENTS_LOG } from "../../../../Config/ApiUrl";
import { axiosGet } from "../../../../../common/Helper/AxiosHelper";

export default {
    name: "EventModal",
    mixins: [FormMixin],
    props: {
        value: {
            type: Boolean,
            required: true
        },
        selectedUrl: {
            type: String,
            default: ''
        },
        data: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            loading: false,
            preloader: false,
            errors: {},
            url: EVENTS_LOG,
            formData: {
                sectionOption: [],
                date: '',
                items: [
                    {
                        section: 'upcoming',
                        category: '',
                        name_event: '',
                        // date_event: '',
                        description: '',
                        employee_name: '',
                        years_count: '',
                        start_time: '',
                        end_time: '',
                    }
                ]
            },
            newSection: {
                name: '',
                order_no: null
            },
            showModal: this.value
        };
    },
    computed: {
        sections() {
            return [
                // { id: 'birthday', name: this.$t('birthday'), order_no: 1 },
                // { id: 'work_anniversary', name: this.$t('work_anniversary'), order_no: 2 },
                { id: 'upcoming', name: this.$t('upcoming'), order_no: 3 },
            ].sort((a, b) => a.order_no - b.order_no);
        }
    },
    created() {
        this.formData.sectionOption = this.sections;
        if (this.selectedUrl) {
            this.preloader = true;
            this.fetchEventData();
        }
    },
    watch: {
        value(newValue) {
            this.showModal = newValue;
        },
        showModal(newValue) {
            if (!newValue) {
                this.$emit('input', false);
                this.$emit('close');
            }
        }
    },
    methods: {
        addItem() {
            this.formData.items.push({
                section: '',
                category: '',
                name_event: '',
                // date_event: '',
                description: '',
                employee_name: '',
                years_count: '',
                start_time: '',
                end_time: '',
            });
        },
        removeItem(index) {
            this.formData.items.splice(index, 1);
        },
        addSection() {
            if (!this.newSection.name || this.newSection.order_no === null) {
                this.$toastr.e(this.$t('section_name_and_order_are_required'));
                return;
            }
            this.formData.sectionOption.push({
                id: this.newSection.name.toLowerCase().replace(/\s+/g, '_'),
                name: this.newSection.name,
                order_no: this.newSection.order_no
            });
            this.sortSections();
            this.newSection.name = '';
            this.newSection.order_no = null;
        },
        sortSections() {
            this.formData.sectionOption.sort((a, b) => a.order_no - b.order_no);
        },
        fetchEventData() {
            axiosGet(this.selectedUrl).then(response => {
                const data = response.data;
                this.formData.date = data.date || ''; // Populate the main date field
                this.formData.items = []; // Clear existing items

                if (data.items && data.items.length > 0) {
                    data.items.forEach(itemData => {
                        this.formData.items.push({
                            section: itemData.action || '',
                            category: itemData.category || '',
                            name_event: itemData.title || '',
                            description: itemData.description || '',
                            employee_name: itemData.employee_name || '',
                            years_count: itemData.years_count || '',
                            start_time: itemData.start_time || '',
                            end_time: itemData.end_time || '',
                        });
                    });
                } else {
                    // If no items are returned, add one empty item to maintain form structure
                    this.formData.items.push({
                        section: '',
                        category: '',
                        name_event: '',
                        description: '',
                        employee_name: '',
                        years_count: '',
                        start_time: '',
                        end_time: '',
                    });
                }
                this.preloader = false;
            }).catch(({response}) => {
                this.$toastr.e(response.data.message);
                this.preloader = false;
                this.closeModal();
            });
        },
        submit() {
            // Get unique section IDs used in items
            const usedSectionIds = [...new Set(this.formData.items.map(item => item.section).filter(Boolean))];

            // Filter sectionOption to only include used sections
            const usedSectionOptions = this.formData.sectionOption.filter(option => usedSectionIds.includes(option.id));

            const payload = {
                ...this.formData,
                sectionOption: usedSectionOptions, // Overwrite with the filtered array
                items: this.formData.items.map(item => ({
                    action: item.section,
                    category: item.category,
                    title: item.name_event,
                    // event_date: item.date_event,
                    description: item.description,
                    employee_name: item.employee_name,
                    years_count: item.years_count,
                    start_time: item.start_time,
                    end_time: item.end_time,
                }))
            };
            this.save(payload);
        },
        beforeSubmit() {
            let isValid = true;
            this.formData.items.forEach((item, index) => {
                if (!item.category) {
                    this.$toastr.e(`${this.$t('category_is_required')} for item #${index + 1}`);
                    isValid = false;
                }
            });
            if (isValid) {
                this.loading = true;
            }
            return isValid;
        },
        afterSuccess(response) {
            this.$toastr.s(response.data.message);
            this.loading = false;
            this.preloader = false;
            this.$emit('reload');
            $('#event-modal').modal('hide');
            this.clearForm();
            this.closeModal();
        },
        afterError(response) {
            this.errors = response.data.errors;
            this.loading = false;
            this.preloader = false;
        },
        clearForm() {
            this.formData.sectionOption = this.sections;
            this.formData.items = [
                {
                    section: '',
                    category: '',
                    name_event: '',
                    description: '',
                    employee_name: '',
                    years_count: '',
                    start_time: '',
                    end_time: '',
                }
            ];
            this.errors = {};
        },
        closeModal() {
            this.showModal = false;
        }
    }
};
</script>

